import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkgroupInformationModel } from 'src/app/models/workgroup-information.model';

@Component({
  selector: 'app-userWorkgroupList',
  templateUrl: './userworkgrouplist.component.html'
})
export class UserWorkgroupListComponent {

  @Input('workgroups') workgroups!: WorkgroupInformationModel[];
  @Input('isOnlyCustomer') isOnlyCustomer: boolean = false
  @Output('removeWorkgroupFromUser') removeWorkgroupFromUser: EventEmitter<string> = new EventEmitter<string>();


  removeWorkgroup(workgroupGuid: string){
    this.removeWorkgroupFromUser.emit(workgroupGuid);
  }

}
